export class Constants {

  public static readonly FIND_MASTER_URL = 'https://www.id37.io/master-finden';

}
